module.exports = __webpack_public_path__ + "img/工厂.152c24bb.png";